import $http from '../../utils/http';
import $httpPost from '../modules/complaintApis/http'
let appraise = 'tio/assessManagement';
//获取用户信息
const getUserInfo = params =>{
    return $http({
        url: appraise + '/login/getLoginInfo',
        headers: { 'showLoading': false },
        params
    })
}
/** 涉旅企业诚信评价进展情况 查询列表 **/
const getIntegrityList = params =>{
    return $http({
        url: appraise + '/api/integrityAssess/findIntegrityAssess',
        headers: { 'showLoading': false },
        params
    })
}
/** 涉旅企业诚信评价进展情况 查询列表 **/
const getIntegrityDetails = params =>{
    return $http({
        url: appraise + '/api/integrityAssess/get',
        headers: { 'showLoading': false },
        params
    })
}
/** 涉旅企业诚信评价进展情况 新增和编辑 **/
const integrityAddAndEdit = data =>{
    return $httpPost({
        url: appraise + '/api/integrityAssess/create',
        headers: { 'showLoading': true },
        data,
        method: 'POST'
    })
}
/** 涉旅企业诚信 附件删除 **/
const delIntegrityFile = data =>  {
    return $httpPost({
        url: appraise + '/file/delete',
        headers: { 'showLoading': true },
        data,
        method: 'POST'
    })
}
/** 涉旅企业诚信删除 **/
const delIntegrity = data =>  {
    return $httpPost({
        url: appraise + '/api/integrityAssess/del',
        headers: { 'showLoading': true },
        data,
        method: 'POST'
    })
}
/** 涉旅企业诚信审核 **/
const auditIntegrity = data =>  {
    return $httpPost({
        url: appraise + '/api/integrityAssess/audit',
        headers: { 'showLoading': true },
        data,
        method: 'POST'
    })
}

export default {
    getUserInfo,
    getIntegrityList,
    getIntegrityDetails,
    delIntegrity,
    integrityAddAndEdit,
    delIntegrityFile,
    auditIntegrity,
}
